import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  plansList,
  addonsList,
  createPlan,
  updatePlan,
  deletePlan,
  createAddon,
  updateAddon,
  deleteAddon,
} from "../../api/subscription";

const initialState = {
  plans: [],
  addons: [],
  total: 0,
  loading: false,
  error: null,
};

export const SubscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    planList: (state, action) => {
      state.plans = action.payload;
    },
    addonList: (state, action) => {
      state.addons = action.payload;
    },
    totalCount: (state, action) => {
      state.total = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { planList, addonList, totalCount, setLoading, clearError } = SubscriptionSlice.actions;

export const plansSelector = (state) => state.subscription.plans;
export const addonsSelector = (state) => state.subscription.addons;
export const totalCountSelector = (state) => state.subscription.total;
export const loadingSelector = (state) => state.subscription.loading;

// Plans Thunks
export const FetchPlans = createAsyncThunk(
  "FetchPlans",
  async (obj, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await plansList(obj);
      if (response?.code === 1) {
        dispatch(planList(response?.data?.plans || []));
        dispatch(totalCount(response?.data?.total || 0));
      }
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const CreatePlan = createAsyncThunk(
  "CreatePlan",
  async (obj, { dispatch }) => {
    try {
      const response = await createPlan(obj);
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const UpdatePlan = createAsyncThunk(
  "UpdatePlan",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await updatePlan(id, data);
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const DeletePlan = createAsyncThunk(
  "DeletePlan",
  async (id, { dispatch }) => {
    try {
      const response = await deletePlan(id);
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

// Addons Thunks
export const FetchAddons = createAsyncThunk(
  "FetchAddons",
  async (obj, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await addonsList(obj);
      if (response?.code === 1) {
        dispatch(addonList(response?.data?.addons || []));
        dispatch(totalCount(response?.data?.total || 0));
      }
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const CreateAddon = createAsyncThunk(
  "CreateAddon",
  async (obj, { dispatch }) => {
    try {
      const response = await createAddon(obj);
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const UpdateAddon = createAsyncThunk(
  "UpdateAddon",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await updateAddon(id, data);
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const DeleteAddon = createAsyncThunk(
  "DeleteAddon",
  async (id, { dispatch }) => {
    try {
      const response = await deleteAddon(id);
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export default SubscriptionSlice.reducer;
